module.exports = __webpack_public_path__ + "img/EXACTFLO_LOGO_BLACKNOWORD.311cd020.png";